import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import type { BackupJob, RestoreJob, ScanJob } from '@repo/api-gw-sdk';
import classNames from 'classnames';
import { CopyToClipboardWrapper } from '@/components/buttons/copyToClipboardButton';
import { Panels } from '@/components/panels/panels';
import { isBackupJob, isRestoreJob, isScanJob } from '@/components/queryBuilder/jobTypeGuards';
import { OverflowTooltip } from '@/components/tooltips/overflowTooltip';
import { useViewParameters } from '@/contexts/navigation';
import { useWorkspace } from '@/contexts/useWorkspace';
export const JobResourceNameField = t0 => {
  const $ = _c(16);
  const {
    job
  } = t0;
  const {
    rightPanel
  } = useWorkspace();
  const {
    removeParam
  } = useViewParameters();
  const resourceName = job.resourceDetails?.resourceName;
  const resourceId = job.resourceDetails?.id;
  let t1;
  if ($[0] !== removeParam || $[1] !== rightPanel) {
    t1 = () => {
      rightPanel.setIsOpen(false);
      removeParam("id");
    };
    $[0] = removeParam;
    $[1] = rightPanel;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onClose = t1;
  let t2;
  if ($[3] !== job || $[4] !== onClose || $[5] !== rightPanel) {
    t2 = () => {
      if (isRestoreJob(job)) {
        rightPanel.setComponent({
          panel: Panels.RestoreJobsCard,
          props: {
            job,
            onClose
          }
        });
      } else {
        if (isBackupJob(job)) {
          rightPanel.setComponent({
            panel: Panels.BackupJobsCard,
            props: {
              job,
              onClose
            }
          });
        } else {
          if (isScanJob(job)) {
            rightPanel.setComponent({
              panel: Panels.ScanJobsCard,
              props: {
                job,
                onClose
              }
            });
          }
        }
      }
    };
    $[3] = job;
    $[4] = onClose;
    $[5] = rightPanel;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onBack = t2;
  let t3;
  if ($[7] !== onBack || $[8] !== onClose || $[9] !== resourceId || $[10] !== rightPanel) {
    t3 = () => {
      if (!resourceId) {
        return;
      }
      rightPanel.setComponent({
        panel: Panels.InventoryInstance,
        props: {
          id: resourceId,
          initialTab: "overview",
          onClose,
          onBack
        }
      });
    };
    $[7] = onBack;
    $[8] = onClose;
    $[9] = resourceId;
    $[10] = rightPanel;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleClick = t3;
  let t4;
  if ($[12] !== handleClick || $[13] !== resourceId || $[14] !== resourceName) {
    t4 = resourceName && <CopyToClipboardWrapper textToCopy={resourceName}><Stack sx={{
        overflow: "hidden",
        maxWidth: "530px"
      }}><OverflowTooltip text={resourceName} renderContent={(text, ref) => <Typography variant="subtitle1" className={classNames("truncate", {
          "underline hover:cursor-pointer hover:text-(--mui-palette-text-secondary)": resourceId
        })} onClick={handleClick} ref={ref}>{text}</Typography>} /></Stack></CopyToClipboardWrapper>;
    $[12] = handleClick;
    $[13] = resourceId;
    $[14] = resourceName;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};